import React from 'react';
import { useLocation } from 'react-router-dom';
import WeatherScreen from '../screens/WeatherScreen';
import type { WeatherAnalyzeResponse } from '../api/endpoints';

export default function WeatherResultPage(): React.JSX.Element {
  const { state } = useLocation() as { state?: { data?: WeatherAnalyzeResponse } };
  return <WeatherScreen mode="page" input={{ data: state?.data }} />;
}
